<template>
  <div>
    <!-- <img width="500" :src="url" /> -->
    <l-map style="height: 85vh; width: 100%" :crs="crs" :options="{ zoomControl: false }">
      <l-image-overlay :url="url" :attribution="attribution" :bounds="bounds"></l-image-overlay>
      <l-control position="bottomleft">
        <b-button @click="addMarker"> Add a marker </b-button>
      </l-control>
      <l-marker v-for="star in stars" :lat-lng="star" :key="star.name" :draggable.sync="star.draggable">
        <l-popup :content="star.name" />
      </l-marker>
    </l-map>
  </div>
</template>

<script>
  import imagemap from './image/map/map.png';
  import { LMap, LImageOverlay, LMarker, LPopup, LControl } from 'vue2-leaflet';
  import { latLng, icon, Icon } from 'leaflet';
  delete Icon.Default.prototype._getIconUrl;
  Icon.Default.mergeOptions({
    iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
    iconUrl: require('leaflet/dist/images/marker-icon.png'),
    shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
  });
  import 'leaflet/dist/leaflet.css';

  export default {
    components: {
      LMap,
      LImageOverlay,
      LMarker,
      LPopup,
      LControl,
    },
    data() {
      return {
        url: imagemap,
        attribution: '&copy; <a target="_blank" href="http://osm.org/copyright">OpenStreetMap</a> contributors',
        bounds: [
          [1519, 1004],
          [0, -25],
        ],
        crs: L.CRS.Simple,
        stars: [
          { name: 'Sol', lng: 300, lat: 500, draggable: 'true' },
          { name: 'Mizar', lng: 330, lat: 550, draggable: 'true' },
          { name: 'Krueger-Z', lng: 320, lat: 540, draggable: 'true' },
          { name: 'Deneb', lng: 340, lat: 650, draggable: 'true' },
        ],
      };
    },
    methods: {
      addMarker() {
        const newMarker = {
          position: { lat: this.lat, lng: this.lng },
          draggable: true,
          visible: true,
        };
        this.markers.push(newMarker);
      },
    },
  };
</script>
